export type SpaceBusinessHour = {
  day_of_week: number
  open_at: string
  close_at: string
  is_open: boolean
  is_24_hours: boolean
}

export type SpaceAvailability = {
  date: string
  day_of_week: number
  day_of_week_label: string
  ratio: number
  is_holiday: boolean
}

export type SpaceType =
  | 'normal'
  | 'jr_east'
  | 'japan_post'
  | 'jr_west'
  | 'nta'
  | 'apaman'
  | 'locker'
  | 'coin_locker'
  | 'pudo'
  | 'multiecube'

export enum SpaceCurrency {
  cny = '¥',
  twd = 'NT$',
  jpy = '¥',
  krw = '₩',
}
export type Currency = 'cny' | 'twd' | 'jpy' | 'krw'

export type SpaceReview = {
  encrypted_id: string
  review_id: string
  space_id: string
  rating: number
  comment: string
  created_at: string
  review_user: {
    last_name: string
    first_name: string
    user_image_url: string
  }
}

export type Space = {
  space_id: string
  encrypted_id: string
  name: string
  longitude: number
  latitude: number
  detailed_place: string
  building: string
  city: string
  prefecture: string
  prefecture_id: number
  prefecture_slug: string
  prefecture_in_text: string
  country_id: number
  postal_code: string
  localed_address: string
  area_section: string
  sub_area_section: string
  google_map_url: string
  nearby_stations: {
    station_name: string
    distance: number
    exit: string
  }[]
  business_hours: SpaceBusinessHour[]
  holiday_business_hours: Omit<SpaceBusinessHour, 'day_of_week'>
  working_hours: SpaceBusinessHour
  can_reserve_multiple_days: boolean
  can_reserve_same_day: boolean
  can_reserve_on_holiday: boolean
  features: {
    accept_on_site_payment: boolean
    english_supported: boolean
    no_smoking: boolean
    has_wifi: boolean
    has_elevator: boolean
    has_charge_spot: boolean
  }
  phone_number: string
  extra_info: string
  fb_account: string
  tw_account: string
  insta_account: string
  homepage_url: string
  introduction: string
  intro_staff_name: string
  intro_staff_type: string
  intro_staff_image_url: string
  capacity: {
    size: 'small' | 'medium' | 'large'
    quantity: number
  }[]
  space_type: SpaceType
  sub_category: string
  main_image_url: string
  jr_east_space_detail: {
    map_image: string
    locker_price: number
  } | null
  jr_west_space_detail: {
    map_image: string
    locker_price: number
  } | null
  reviews: {
    comment: string
    user_name: string
  } | null
  top_reviews: SpaceReview[]
  space_photos: { url: string; photo_description: string }[]
  prices: {
    size: 'small' | 'medium' | 'large'
    price: number
  }[]
  sizes?: Array<{
    size: string | null
    width: number | null
    length: number | null
    height: number | null
  }>
  availabilities: SpaceAvailability[]
  average_review_rating: number
  total_review_count: number
  fully_status_updated_at: string
  recent_reservations_count: number
}
